"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
require("./forminputs.style.css");
const classnames_1 = __importDefault(require("classnames"));
function CustomDropDown(props) {
    const { id, name, title, options, onChange, value, icon, className, right, isAlternateText, isCaretIcon, customDropDownFooter, disabled, } = props;
    const [isOpen, setOpen] = react_1.useState(false);
    const onOptionClick = (value) => {
        setOpen(!isOpen);
        onChange && onChange(value);
    };
    return (react_1.default.createElement(reactstrap_1.UncontrolledDropdown, { className: className, isOpen: isOpen, id: id, name: name, value: value, toggle: () => setOpen(!isOpen), disabled: disabled },
        react_1.default.createElement(reactstrap_1.DropdownToggle, { tag: "a", className: classnames_1.default({
                'text-info': !disabled,
                'text-muted': disabled,
                'cursor-pointer text-decoration-none text-nowrap': true,
            }), caret: false, "aria-expanded": isOpen },
            icon && react_1.default.createElement("i", { className: icon, "aria-hidden": "true" }),
            title && title,
            isCaretIcon && (react_1.default.createElement("i", { className: "fa fa-caret-down pl-2", "aria-hidden": "true" }))),
        react_1.default.createElement(reactstrap_1.DropdownMenu, { className: "custom-dropdown-menu test-options-menu", right: right },
            options &&
                options.map((option, index) => (react_1.default.createElement(reactstrap_1.DropdownItem, { "data-test": `${name}-item-${index}`, className: "cursor-pointer d-flex align-items-center test-options-item", key: index, active: option.value === value, onClick: () => onOptionClick(option.value), disabled: option.disabled || false }, option.label))),
            !options.length && isAlternateText && isAlternateText,
            customDropDownFooter && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(reactstrap_1.DropdownItem, { className: "test-divider", divider: true }),
                react_1.default.createElement(reactstrap_1.DropdownItem, { disabled: true }, customDropDownFooter))))));
}
exports.default = CustomDropDown;
//# sourceMappingURL=drop-down.component.js.map